import { React } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(fal);

const fontSize = {
  xs: '10px',
  sm: '12px',
  lg: '15px',
  '2x': '20px',
  '3x': '24px',
};
/**
 * Add/Delete Tags at Contexture for a document
 * @param {string} text - String that will show next to icon spinner
 * @param {string} size - xs, sm, lg, 2x, 3x
 * @public
 */
const Loading = ({ text, size, cstmclass= false }) => {
  return (
    <div className={`ctx-loading ${cstmclass ? "sort-loading" : ""}`}>
      <FontAwesomeIcon
        icon={['fal', 'spinner']}
        title='Loading...'
        className='fa-spin'
        size={size || 'lg'}
      />
      <span style={{ fontSize: size ? fontSize[size] : fontSize['lg'] }}>
        {text && text.length ? text : ''}
      </span>
    </div>
  );
};
export default Loading;
